// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__zrgqJ","HeroImg":"Hero_HeroImg__MD2uz","HeroContent":"Hero_HeroContent__TzjFJ"};